import { FIELD_REGEXP } from '@common/utils/regExp'

export default {
    data() {
        const validateCnName = (rule, value, callback) => {
            if (value.length > 50) {
                callback(
                    new Error('输入的名称不能超过50个字')
                )
                return
            }
            if (!/^([^\s])(?!.*?_$)(?!.*_{2,})[^\s]{0,}$/.test(value)) {
                callback(new Error('请输入不以下划线结尾且不包含2个连续下划线的名称'))
                return
            }
            callback()
        }
        const validateEnField = (rule, value, callback) => {
            if (!FIELD_REGEXP.test(value)) {
                callback(new Error('请输入英文、数字、下划线，英文字母开头，不以下划线结尾，且不包含2个连续下划线'))
                return
            }
            callback()
        }

        return {
            objectRules: {
                title: [{
                    required: true,
                    message: '请输入显示名称',
                    trigger: 'blur',
                }, { validator: validateCnName, trigger: 'blur' }],
                name: [
                    { validator: validateEnField, trigger: 'blur' },
                    { required: true, message: '请输入对象名称', trigger: 'blur' },
                    { validator: validateCnName, trigger: 'blur' },
                ],
            },
        }
    },
}
